<template>
  <section>
    
  </section>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    
  },
  data () {
    return {
      currentUser: localStorage.getItem('profile') ? JSON.parse(atob(localStorage.getItem('profile'))) : null,
    }
  },
  mounted () {
    const year = moment().subtract(1, 'year').year()
    const route = `https://api2.rededecisao.com/api/declaracaoporemail/${process.env.VUE_APP_LARAVEL_API_LOGIN_TOKEN}/${this.currentUser.email}/${year}` 

    // console.log("route:", route)
    window.location.href = route
  }
}
</script>

<style>

</style>